import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY, from, Observable, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { LOGIN_QUERY, LOGIN_QUERY_LOGOUT_REASON_MAP, LOGOUT_REASON } from '../../constants';
import { ROUTE_ID, ROUTES } from '../../constants/api-routes';
import { ALREADY_CONFIRMED_LEAVING_PROJECT_NAVIGATION_EXTRAS } from '../../projects/edit-project/constants';
import { AuthenticationService } from '../../projects/services/authentication.service';
import { RouterService } from './router.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private readonly authSvc = inject(AuthenticationService);
    private readonly routerSvc = inject(RouterService);

    public intercept(request: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let authToken: string;
        if (this.authSvc) {
            authToken = this.authSvc.getBearerToken();
        }

        if (request?.url && authToken && request.url.includes(environment.apiUrl)) {
            if (!this.authSvc.hasValidAccessToken() && !request.url.includes(ROUTES[ROUTE_ID.LOGOUT])) {
                return from(
                    this.routerSvc.navigateToLogout({
                        queryParams: {
                            [LOGIN_QUERY_LOGOUT_REASON_MAP[LOGOUT_REASON.UNAUTHORIZED]]: LOGOUT_REASON.UNAUTHORIZED,
                            [LOGIN_QUERY.RETURN_URL]: this.routerSvc.getValidReturnUrl(this.routerSvc.currentUrl)
                        },
                        ...ALREADY_CONFIRMED_LEAVING_PROJECT_NAVIGATION_EXTRAS
                    })
                ).pipe(
                    switchMap(() => {
                        console.log(
                            `Attempt to trigger ${request.url} with an expired token: ${this.authSvc.getAccessTokenExpiration()}`
                        );
                        return EMPTY;
                    })
                );
            }

            request = request.clone({
                setHeaders: {
                    Authorization: authToken
                }
            });
        }

        return next.handle(request);
    }
}
